var TyreInformation = (function ($) {

    function initialize() {
        var backgroundInput = $("#tyre-information-background-input");
        if (!backgroundInput.length) {
            return;
        }

        var backgroundImageUrl = backgroundInput.val();
        if (!backgroundImageUrl) {
            return;
        }

        var backgroundCssValue = "url('" + backgroundImageUrl + "') #fff no-repeat fixed center top";
        $("body").css("background", backgroundCssValue);
    }

    return {
        initialize: initialize
    };

})($);

$(function () {
    TyreInformation.initialize();
});